import { STYLES } from '../constants.js';

export function LoadingSlide({ isFullPageMode = false }) {
  // Scroll to the nearest data-sign-up-block on render
  // isFullPageMode means no scrolling is required
  if (!isFullPageMode && typeof window !== 'undefined') {
    setTimeout(() => {
      const block = document.querySelector('.swiper-signup');
      if (block) {
        const rect = block.getBoundingClientRect();
        window.scrollTo({
          top: window.scrollY + rect.top - 100,
          behavior: 'smooth',
        });
      }
    }, 0);
  }
  return (
    <div className="mx-auto flex flex-col items-center text-center">
      <video className="w-40 aspect-square" autoPlay loop muted playsInline>
        <source src="/static/video/loading.mp4" type="video/mp4" />
      </video>
      <p className="text-xl font-bold text-charcoal-800">
        Your account is being created!
      </p>
      <h3 className={`${STYLES.formStepTitle}`}>This might take a minute</h3>
      <p className="text-balance text-charcoal-800">
        We're adding the final touches to your beautiful booking and payments
        system, stay tuned.
      </p>
    </div>
  );
}
